import { createMutationHelper } from '@utils/swr'
import { type UnbindIdentityRequest } from '../../../types/apiRequest'
import { type UnbindResponse } from '../../../types/apiResponse'
import { type CosignApis } from '../../../types/apis'

const {
  useMutation,
} = createMutationHelper<CosignApis['post']['unbind'], UnbindResponse, UnbindIdentityRequest>({
  client: 'cosign',
  key: '/api/platform-sdk/wordpress-unbind',
  fetcher: (url, { arg, client }) => {
    return client.post(url, arg)
  },
})

export const useRequestUnbindIdentity = useMutation
